import _ from "lodash";
import { Mapper } from "../domain/mappers/Mapper";
import {
    WorkSearchSortForm,
    WorkSearchSortDTO,
} from "../domain/models/dto/WorkDTO";
import { SimpleMapper } from "./SimpleMapper";
import { SortingOrder } from "../domain/enums/common/SortingOrderEnum";
import { WorkDefaultSortingFields } from "../domain/enums/entity-fields/WorkSortingFields";

class WorkSearchSortMapperImpl extends SimpleMapper<
    WorkSearchSortForm,
    WorkSearchSortDTO
> {
    protected toDTOFields: string[] = [
        "title",
        "showInactive",
        "showOnlyActive",
        "showOnlyInactive",
        "price",
        "distance",
        "startFrom",
    ];

    toDTO(form: WorkSearchSortForm): WorkSearchSortDTO {
        const dto = super.toDTO(form);
        dto.categories = (_.get(form, "categories") || []).map(
            (item) => item.category
        );
        const hasExplicitSorting = [
            dto.price,
            dto.distance,
            dto.startFrom,
        ].some(
            (sortingOrder) =>
                sortingOrder && sortingOrder !== SortingOrder.DEFAULT
        );

        // API contract: an otherwise unsorted collection is globally ordered by
        // creation time before pagination is applied. Visible user-selected sort
        // fields remain authoritative and suppress this fallback.
        if (!hasExplicitSorting) {
            dto.sort = WorkDefaultSortingFields.CREATED_AT;
            dto.sortingOrder = SortingOrder.DESC;
        }
        return dto;
    }
}

export default function workSearchSortMapperFactory(): Mapper<
    WorkSearchSortForm,
    WorkSearchSortDTO
> {
    return new WorkSearchSortMapperImpl();
}
